import React from 'react';
import { I18n } from 'react-redux-i18n';

const AffiliateNetworkSettings = ({ isEnable, onToggle }) => (
  <div className="network-setting-section">
    <h3 className="section-title">{
      I18n.t('networkSetting.title')}
    </h3>
    <p className="section-description">
      {I18n.t('networkSetting.descriptionPart1')}
      <span onClick={() => window.open('https://www.goodjourney.io/en/gsn-policy', '_blank')} style={{ color: '#04BE76', cursor: 'pointer' }}>{I18n.t('networkSetting.descriptionPart2')}</span>
      {I18n.t('networkSetting.descriptionPart3')}
      <span onClick={() => window.open('https://www.goodjourney.io/en/gsn-penalty-policy', '_blank')} style={{ color: '#04BE76', cursor: 'pointer' }}>{I18n.t('networkSetting.descriptionPart4')}</span>
      {I18n.t('networkSetting.descriptionPart5')}
    </p>
    <div className="toggle-switch-container">
      <label className="toggle-switch">
        <input
          type="checkbox"
          checked={isEnable}
          onChange={onToggle}
        />
        <span className="toggle-slider"></span>
      </label>
    </div>
  </div>
);

export default AffiliateNetworkSettings;